export function scrollIntoViewWithOffset(element: HTMLElement): void {
  let scrollableParent: HTMLElement | null = element.parentElement;
  while (scrollableParent) {
    const style = window.getComputedStyle(scrollableParent);
    if (style.overflowY === "auto" || style.overflowY === "scroll") {
      break;
    }
    scrollableParent = scrollableParent.parentElement;
  }

  if (!scrollableParent) {
    element.scrollIntoView({ behavior: "smooth", block: "nearest" });
    return;
  }

  requestAnimationFrame(() => {
    const elementRect = element.getBoundingClientRect();
    const parentRect = scrollableParent.getBoundingClientRect();
    const clientHeight = scrollableParent.clientHeight;
    const scrollTop = scrollableParent.scrollTop;

    const elementTop = elementRect.top - parentRect.top + scrollTop;
    const elementBottom = elementTop + elementRect.height;

    const allElements = scrollableParent.querySelectorAll("*");
    let stickyTopHeight = 0;
    let stickyBottomHeight = 0;

    allElements.forEach((el) => {
      const style = window.getComputedStyle(el);
      if (style.position === "sticky") {
        const elRect = el.getBoundingClientRect();
        const elHeight = elRect.height;

        if (style.top !== "auto") {
          stickyTopHeight = Math.max(stickyTopHeight, elHeight);
        }

        if (style.bottom !== "auto") {
          stickyBottomHeight = Math.max(stickyBottomHeight, elHeight);
        }
      }
    });

    const usableTop = scrollTop + stickyTopHeight;
    const usableBottom = scrollTop + clientHeight - stickyBottomHeight;

    const breathingRoom = 16;
    let targetScrollTop = scrollTop;

    if (elementTop < usableTop) {
      targetScrollTop = Math.max(0, elementTop - stickyTopHeight - breathingRoom);
    } else if (elementBottom > usableBottom - breathingRoom) {
      targetScrollTop = elementBottom + stickyBottomHeight + breathingRoom - clientHeight;
    }

    const maxScroll = Math.max(0, scrollableParent.scrollHeight - clientHeight);
    targetScrollTop = Math.max(0, Math.min(targetScrollTop, maxScroll));

    scrollableParent.scrollTo({
      top: targetScrollTop,
      behavior: "smooth",
    });
  });
}
